export default __webpack_public_path__ + "static/media/what-we-provide-infrastructure-icon.a4e25cf7.svg";